import type { cardApiSpec } from "@wingspanhq/wingspan-api-types";

const EMBEDDED_CARD_STATUSES: Record<cardApiSpec.PaymentCardStatus, string> = {
  Active: "ACTIVE",
  Inactive: "SUSPENDED",
  Closed: "CANCELLED",
  OneTime: "ONE_TIME",
  PendingActivation: "PENDING_ACTIVATION",
  PendingFulfillment: "PENDING_FULFILLMENT"
};

export const selectorEmbeddedCardStatus = (
  status: cardApiSpec.PaymentCardStatus
) => EMBEDDED_CARD_STATUSES[status];
